<template>
    <section class="relative isolate overflow-hidden bg-white px-6 py-16 md:py-24 lg:px-8" id="testimonials">
        <div class="w-full max-w-6xl mx-auto">
            <div class="text-center max-w-xl mx-auto">
                <span
                    class="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-600/10">Testimonials</span>
                <p
                    class="mt-4 text-pretty text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl lg:text-balance">
                    What people are saying
                </p>
            </div>
            <div class="-mx-3 md:flex items-start mt-8 sm:mt-16 lg:mt-20">
                <div v-for="(group, index) in groupedTestimonials" :key="index" class="px-3 md:w-1/3">
                    <div v-for="testimonial in group" :key="testimonial.id"
                        class="relative w-full mx-auto rounded-2xl bg-white ring-1 ring-slate-900/5 shadow-sm p-6 text-slate-800 font-light mb-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                        <span class="absolute right-6 top-4 text-5xl font-serif italic text-accent-300"
                            aria-hidden="true">"</span>
                        <div class="w-full flex mb-4 items-center">
                            <div
                                class="overflow-hidden rounded-full w-10 h-10 bg-slate-50 ring-2 ring-primary-200">
                                <img src="/images/default-avatar.png" alt="">
                            </div>
                            <div class="flex-grow pl-3">
                                <h6 class="font-bold uppercase text-slate-600 text-sm">{{ testimonial.name }}</h6>
                            </div>
                        </div>
                        <div class="w-full">
                            <p class="leading-relaxed text-slate-600">{{ testimonial.testimonial }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

const testimonials = ref([]);
const groupedTestimonials = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/testimonials');
    testimonials.value = response.data.data;

    for (let i = 0; i < testimonials.value.length; i += 2) {
        groupedTestimonials.value.push(testimonials.value.slice(i, i + 2));
    }
});
</script>